import { useMemo, useState } from 'react';
import { filterStaffMembers, getStaffCounters } from '@/modules/staff/utils';

export function useStaffFilters(staffList) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterTipo, setFilterTipo] = useState('tutti');

  const filteredStaff = useMemo(
    () => filterStaffMembers(staffList, { searchTerm, filterTipo }),
    [staffList, searchTerm, filterTipo]
  );

  const counters = useMemo(() => getStaffCounters(staffList), [staffList]);

  return {
    searchTerm,
    setSearchTerm,
    filterTipo,
    setFilterTipo,
    filteredStaff,
    counters,
  };
}
